export var TeamAccountMemberLimitReachedStrings = {
    limitationErrorBannerTitle: function () {
        return "You've exceeded the maximum number of members";
    },
    contactSales: function () { return "Contact sales"; },
    canOnlyAddCountToTeam: {
        singleAdd: function (n) { return "You can only add " + n + " member to your Team plan."; },
        multipleAdd: function (n) {
            return "You can only add " + n + " members to your Team plan.";
        },
    },
    upgradePlan: function () { return 'to upgrade to the Enterprise plan which offers spots.'; },
};
